import { StatusBannerLevel } from 'utils/types'

export interface StatusBannerItem {
  id: string
  level: StatusBannerLevel
  title: string
  description: string
  href: string | null
  linkLabel: string | null
}

export const BANNER_HEIGHT = 48

export const HEADER_FONT = '\'DM Sans\', sans-serif'

interface LevelStyle {
  bg: string
  text: string
  icon: string
  iconChipBg: string
  divider: string
  counterBg: string
  closeColor: string
}

// Theme palette paths (resolved by sx), mapped to the nearest theme
// color for each token in the design handoff. The white alphas have
// no palette tokens — they are opacity treatments on the dark surface.
export const LEVEL_STYLES: Record<StatusBannerLevel, LevelStyle> = {
  info: {
    bg: 'nonary.background',
    text: 'black.main',
    icon: 'info.main',
    iconChipBg: 'nonary.background',
    divider: 'divider',
    counterBg: 'action.selected',
    closeColor: 'action.active'
  },
  important: {
    bg: 'black.main',
    text: 'white.main',
    icon: 'brand.background',
    iconChipBg: 'rgba(255, 255, 255, 0.1)',
    divider: 'rgba(255, 255, 255, 0.18)',
    counterBg: 'rgba(255, 255, 255, 0.12)',
    closeColor: 'rgba(255, 255, 255, 0.6)'
  }
}

export const sortByLevel = (banners: StatusBannerItem[]): StatusBannerItem[] =>
  [...banners].sort((a, b) => {
    if (a.level === b.level) {
      return 0
    }

    return a.level === 'important' ? -1 : 1
  })
